import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const infoEmail = 'infopagosdepgfmluz@gmail.com'

const ModalConsultaEstatus = ({ toggleFunction, modalState }) => {
  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Consulta tu estatus administrativo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-center'>

          <div className='info-group mt-1'>
            <span className='info-span'>Consulta tu estatus administrativo mediante el correo electrónico: </span>
            <a href={`mailto:${infoEmail}`} className='std-link fw-semibold' target='blank'>
              {infoEmail}
            </a>
          </div>

          <div className='info-group text-start'>
            <ul className='std-list mb-0'>
              <li className='list-item mb-3'>
                <p className='mb-0'>
                  Los pagos de cada trimestre se deben cumplir los primeros cinco (05) días del inicio de trimestre.
                </p>
              </li>
              <li className='list-item mb-0'>
                Para realizar cualquier proceso académico o administrativo es importante estar solvente con la División.
              </li>
            </ul>
          </div>

          <div className='info-group mt-2'>
            <h4 className='heading-title-md fw-bold mb-3'>Horario de Atención</h4>

            <p className='mb-1'>Lunes a viernes de 8:30 am a 4:00 pm</p>
            <p>Lugar: Edificio Ciencia y Salud</p>
          </div>

          <div className='info-group'>
            <p className='fw-semibold mb-1'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-0'>Director</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalConsultaEstatus }